// extracted by mini-css-extract-plugin
export default {"h2":"Footer_h2__3cb5Y","contacts":"Footer_contacts__ZbE-g","container":"Footer_container__2afkR"};